import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	enabled?: boolean;
}

const fetchStoreById = async (storeId?: number | null) => {
	if (!storeId) {
		return Promise.reject(new Error(`invalid store id: ${storeId}`));
	}

	const url = `/store/store/${storeId}/`;

	const { data } = await cmsClient.get<Store>(url);

	return data;
};

const useStore = (
	storeId?: number | null,
	options: Options = { enabled: true }
) => {
	const query = useQuery(["store", storeId], () => fetchStoreById(storeId), {
		enabled: options.enabled
	});

	return query;
};

export default useStore;
